import React from "react";
import Helmet from "react-helmet";
import styled from "styled-components";
import { isRouteErrorResponse, useRouteError } from "react-router-dom";
import PageLink from "./PageLink";

const Container = styled.div`
  margin: 64px auto;
  max-width: 800px;
  padding: 40px 16px;
  text-align: center;

  h1 {
    font-family: "BryantWebBold";
    font-size: 36px;
    font-weight: 700;
    line-height: 48px;
    letter-spacing: -1px;
    color: var(--title);
    margin: 0 0 16px;
  }

  p {
    font-family: Nunito;
    font-size: 18px;
    font-weight: 700;
    line-height: 24px;
    color: var(--subtitle);
    margin: 0 0 12px;

    a {
      color: var(--link-color);
    }
  }
`;

const ErrorPage = ({ title, detail }: { title: string; detail: string }) => (
  <Container>
    <Helmet>
      <title>SignUp Media - {title}</title>
    </Helmet>
    <h1>{title}</h1>
    <p>{detail}</p>
    <p>
      <PageLink to="/">Go to the home page</PageLink>
    </p>
  </Container>
);

/** Catch-all route for URLs that match nothing. */
export const NotFound = () => (
  <ErrorPage
    title="Page not found"
    detail="That link does not lead anywhere on this site."
  />
);

/**
 * Error boundary for the layout route. Rendered inside the site chrome so a
 * bad URL or a page that throws still leaves the reader with navigation.
 */
const RouteError = () => {
  const error = useRouteError();
  if (isRouteErrorResponse(error) && error.status === 404) {
    return <NotFound />;
  }
  return (
    <ErrorPage
      title="Something went wrong"
      detail="This page hit an error. Please try again in a moment."
    />
  );
};

export default RouteError;
